import React from 'react';

import { Box, Button } from '@mui/material';

function PcqNotes (props) {
    let { notes, handleClose } = props;

    /***** CONST *****/
    const styleContent = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '90%',
        maxWidth: '600px',
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        pt: 2,
        px: 4,
        pb: 3,
        overflow: 'auto',
        maxHeight: '80%',
    };

    /***** MAIN *****/
    return (
        <>
            <Box sx={{ ...styleContent }}>
                <h2>Note di lavoro</h2>
                <p>{notes}</p>
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                    <Button variant="contained" onClick={handleClose}>Chiudi</Button>
                </Box>
            </Box>
        </>
    );
}

export default PcqNotes ;